export default __webpack_public_path__ + "static/media/accessories.608cd292.png";